<template>
  <FormBuilder
    class="space-y-4"
    :validation-schema="validationSchema"
    :initial-values="initialValues"
    @submit="onSubmit"
    @input="error = null"
    v-slot="{ isSubmitting }"
  >
    <InputText id="name" name="name" :label="$t('channelName')" required />
    <SingleSelect
      id="typeId"
      name="typeId"
      :label="$t('channelType')"
      :placeholder="$t('selectChannelType')"
      :options="getChannelTypeAsOptions"
      required
    />
    <SingleSelect
      id="scopes"
      name="scopes"
      :label="$t('scope')"
      :placeholder="$t('selectScope')"
      :options="getScopeListAsOptions"
      required
    />
    <InputText id="cidr" name="cidr" :label="$t('cidr')" />
    <div class="text-end">
      <BaseButton type="submit" :disabled="isSubmitting">{{
        $t("startCreate")
      }}</BaseButton>
    </div>
    <BaseBoxColor v-if="error" class="w-full" variant="danger">{{
      error
    }}</BaseBoxColor>
  </FormBuilder>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import useChannelTypeStore from "@/stores/channelType";
import useScopeStore from "@/stores/scope";
import useChannelStore from "@/stores/channel";
import useModalStore from "@/stores/modal";
import useToastStore from "@/stores/toast";
import validationSchema from "./validationSchemas.js";

const { fetchScopeList } = useScopeStore();
onMounted(() => {
  fetchScopeList();
});

const { getChannelTypeAsOptions } = useChannelTypeStore();
const { getScopeListAsOptions } = storeToRefs(useScopeStore());
const { addChannel } = useChannelStore();
const { addToast } = useToastStore();
const { closeModal } = useModalStore();
const error = ref(null);
const { t } = useI18n();

/**
 * handle form submit
 * @param {Object} values
 * @param {Function} resetForm
 */
async function onSubmit(values) {
  try {
    await addChannel(values);
    addToast({
      content: t("itemCreated"),
      variant: "success",
    });
    closeModal();
  } catch (err) {
    error.value = err;
  }
}
</script>
